import { render, staticRenderFns } from "./About.vue?vue&type=template&id=8acd55a6&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&id=8acd55a6&lang=scss&scoped=true&"
import style1 from "./About.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acd55a6",
  null
  
)

export default component.exports